<app-search-univ-base
  [isSearchSummaryDisplayed]="isSearchSummaryDisplayed"
  [matchedUniversityCount$]="matchedUniversityCount$"
  [defaultDepartmentCategory]="defaultDepartmentCategory"
  [previousCondition]="previousCondition"
  [searchButtonDisabled$]="searchButtonDisabled$"
  [universityCountSearching$]="universityCountSearching$"
  [isBToC]="true"
  [selectableYears]="selectableYears"
  (menuHandlerClick)="menuClickHandler($event)"
  (changeValues)="onChangeValues($event)"
  (resetFormsClick)="resetForms($event)"
  (showSearchResultViewClick)="showSearchResultView()"
></app-search-univ-base>

<!-- 志望校ショートカット（モックアップ） -->
<div *ngIf="!isSearchSummaryDisplayed && hasDesiredUniversities">
  <app-content-row>
    <app-wrapper size="lg" isFitWithSmallScreen="true">
      <div class="px-4 md:px-0">
        <div class="flex items-center gap-1 mt-1 mb-4">
          <mat-icon class="text-primary !text-base !size-4">flag</mat-icon>
          <span class="text-sm font-bold">志望校の過去問を見る</span>
        </div>
        <div class="flex flex-wrap gap-2" *ngIf="(desiredUniversities$ | async)?.length > 0; else loadingDesiredUniversities">
          <button
            *ngFor="let univ of desiredUniversities$ | async"
            mat-flat-button
            class="bookmark-univ-tag"
            [disabled]="univ.isDisabled"
            (click)="onDesiredUnivClick(univ.id)"
          >
            {{ univ.name }}
          </button>
        </div>
        <ng-template #loadingDesiredUniversities>
          <app-content-row>
            <app-wrapper size="lg" isFitWithSmallScreen="true">
              <div class="px-4 md:px-0">
                <mat-spinner [diameter]="24"></mat-spinner>
              </div>
            </app-wrapper>
          </app-content-row>
        </ng-template>
      </div>
    </app-wrapper>
  </app-content-row>
</div>

<ng-template #searchUnivResult></ng-template>

<div *ngIf="isShowMoreButtonShown$ | async">
  <app-content-row>
    <app-wrapper size="lg" isFitWithSmallScreen="true">
      <div class="pb-8">
        <app-button-more canSpinner="true" [pageButton]="this.pageButton" (buttonClick)="showMoreResults()"></app-button-more>
      </div>
    </app-wrapper>
  </app-content-row>
</div>

<div class="progress-48-search-result-loading py-6 md:py-8" *ngIf="(isUniversitySearching$ | async) && this.currentPage === 1">
  <mat-spinner [diameter]="48"></mat-spinner>
</div>
